if (!process.env.VUE_APP_IS_WEB) {
  var RecipientMeetingDocDB = require("../database/models/RecipientMeetingDoc");
}
import strings from "@/database/strings";

import RecipientMeetingDocORM from "@/store/orm-axios/models/RecipientMeetingDoc";

import { _ } from "vue-underscore";

export default {
  GET(id) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new RecipientMeetingDocDB({ id: id, deleted: null })
          .fetch()
          .then(res => {
            RecipientMeetingDocORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        RecipientMeetingDocORM.api()
          .GET(id)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  POST(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new RecipientMeetingDocDB(item)
          .save()
          .then(res => {
            var configuration = res.serialize();
            RecipientMeetingDocORM.insertOrUpdate({
              data: configuration,
            });
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        RecipientMeetingDocORM.api()
          .POST(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  PUT(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new RecipientMeetingDocDB(item)
          .save(null, { isUpdate: true })
          .then(res => {
            RecipientMeetingDocORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        RecipientMeetingDocORM.api()
          .PUT(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  DELETE(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new RecipientMeetingDocDB(item)
          .save(null, { isDelete: true })
          .then(res => {
            RecipientMeetingDocORM.delete(item.id);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        RecipientMeetingDocORM.api()
          .DELETE(item)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  GET_BY_MEETING(meetingId, save, asl) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO Add process
    } else {
      return new Promise((resolve, reject) => {
        RecipientMeetingDocORM.api()
          .GET_BY_MEETING(meetingId, save, asl)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  GET_FOR_ASL(queryParams) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO Add process
    } else {
      return new Promise((resolve, reject) => {
        RecipientMeetingDocORM.api()
          .GET_FOR_ASL(queryParams)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
};
